import { AvatarSize, AvatarType, ExAvatar } from '@boomi/exosphere';
import type { DataAttributes } from '../types/dataAttributes';
import styles from './ConnectorRow.module.css';
import type { Connector } from './connectors';

interface ConnectorRowProps extends DataAttributes {
    connector: Connector;
    onViewConnections?: (id: string) => void;
}

const ConnectorRow = ({ connector, onViewConnections, ...dataAttributes }: ConnectorRowProps) => {
    const { id: connectorId, name, icon } = connector;

    return (
        <button
            className={styles.row}
            onClick={() => onViewConnections?.(connectorId)}
            aria-label={name}
            type="button"
            {...dataAttributes}
        >
            <div className={styles.iconWrap}>
                {icon ? (
                    <img src={icon} alt={name} width={24} height={24} />
                ) : (
                    <ExAvatar
                        size={AvatarSize.SMALL}
                        avatarType={AvatarType.USER}
                        firstName={name.split(' ')[0]}
                        lastName={name.split(' ')[1] ?? ''}
                    />
                )}
            </div>
            <span className={styles.name}>{name}</span>
        </button>
    );
};

export default ConnectorRow;
